import React from 'react'
import { FaGithub, FaLinkedinIn, FaDocker } from "react-icons/fa";
import { SiKubernetes, SiTypescript, SiNestjs } from "react-icons/si";
import { IoLogoNodejs } from 'react-icons/io';

const Media = () => {
  return (
    <div className="flex flex-col xl:flex-row gap-8 lgl:gap-0 justify-between">
      <div>
        <p style={{
          fontFamily: "'JetBrains Mono', monospace",
          fontSize: "11px",
          color: "#4a5568",
          letterSpacing: "0.12em",
          textTransform: "uppercase",
          marginBottom: "14px",
        }}>
          // find_me_at
        </p>
        <div className="flex gap-3">
          <span className="bannerIcon">
            <a href="https://github.com/bipro-b?tab=repositories" target="_blank" rel="noreferrer"><FaGithub /></a>
          </span>
          <span className="bannerIcon">
            <a href="https://www.linkedin.com/in/bipro-barai-419381179/" target="_blank" rel="noreferrer"><FaLinkedinIn /></a>
          </span>
        </div>
      </div>
      <div>
        <p style={{
          fontFamily: "'JetBrains Mono', monospace",
          fontSize: "11px",
          color: "#4a5568",
          letterSpacing: "0.12em",
          textTransform: "uppercase",
          marginBottom: "14px",
        }}>
          // core_stack
        </p>
        <div className="flex gap-3">
          <span className="bannerIcon" title="Node.js"><IoLogoNodejs /></span>
          <span className="bannerIcon" title="TypeScript"><SiTypescript /></span>
          <span className="bannerIcon" title="NestJS"><SiNestjs /></span>
          <span className="bannerIcon" title="Docker"><FaDocker /></span>
          <span className="bannerIcon" title="Kubernetes"><SiKubernetes /></span>
        </div>
      </div>
    </div>
  )
}

export default Media;